/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { HistoricalValueDTO } from '../model/historicalValueDTO';
import { HistoricalValuePresentationDTO } from '../model/historicalValuePresentationDTO';
import { PageHistoricalValueDTO } from '../model/pageHistoricalValueDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class HistoricalValueControllerService {

    protected basePath = 'https://localhost:8084';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve the Historical Value corresponding to the given product id and settlement date
     * Retrieve the Historical Value corresponding to the given product id and settlement date
     * @param productId productId
     * @param settlementDate settlementDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValueForProductOnSettlementDateUsingGET(productId: string, settlementDate: string, observe?: 'body', reportProgress?: boolean): Observable<HistoricalValueDTO>;
    public findHistoricalValueForProductOnSettlementDateUsingGET(productId: string, settlementDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HistoricalValueDTO>>;
    public findHistoricalValueForProductOnSettlementDateUsingGET(productId: string, settlementDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HistoricalValueDTO>>;
    public findHistoricalValueForProductOnSettlementDateUsingGET(productId: string, settlementDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling findHistoricalValueForProductOnSettlementDateUsingGET.');
        }
        if (settlementDate === null || settlementDate === undefined) {
            throw new Error('Required parameter settlementDate was null or undefined when calling findHistoricalValueForProductOnSettlementDateUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<HistoricalValueDTO>(`${this.basePath}/api/historical-values/subset/${encodeURIComponent(String(productId))}/for-settlement-date/${encodeURIComponent(String(settlementDate))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * findHistoricalValuesForPresentationForProductTypeIdBetweenDates
     * 
     * @param productTypeId productTypeId
     * @param startDate startDate
     * @param endDate endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<HistoricalValuePresentationDTO>>;
    public findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HistoricalValuePresentationDTO>>>;
    public findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HistoricalValuePresentationDTO>>>;
    public findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<HistoricalValuePresentationDTO>>(`${this.basePath}/api/historical-values/for-presentation/by-product-type/${encodeURIComponent(String(productTypeId))}/between-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the list of Historical Values corresponding to the given product id between the given dates
     * Retrieve the list of Historical Values corresponding to the given product id between the given dates
     * @param productId productId
     * @param startDate startDate
     * @param endDate endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForProductBetweenDatesUsingGET(productId: string, startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<HistoricalValueDTO>>;
    public findHistoricalValuesForProductBetweenDatesUsingGET(productId: string, startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductBetweenDatesUsingGET(productId: string, startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductBetweenDatesUsingGET(productId: string, startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling findHistoricalValuesForProductBetweenDatesUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findHistoricalValuesForProductBetweenDatesUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findHistoricalValuesForProductBetweenDatesUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<HistoricalValueDTO>>(`${this.basePath}/api/historical-values/subset/${encodeURIComponent(String(productId))}/between-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the list of Historical Values corresponding to the given product id between the given dates with previous entries of offset
     * Retrieve the list of Historical Values corresponding to the given product id between the given dates with previous entries of offset
     * @param productId productId
     * @param startDate startDate
     * @param endDate endDate
     * @param offset offset
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET(productId: string, startDate: string, endDate: string, offset: number, observe?: 'body', reportProgress?: boolean): Observable<Array<HistoricalValueDTO>>;
    public findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET(productId: string, startDate: string, endDate: string, offset: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET(productId: string, startDate: string, endDate: string, offset: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET(productId: string, startDate: string, endDate: string, offset: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET.');
        }
        if (offset === null || offset === undefined) {
            throw new Error('Required parameter offset was null or undefined when calling findHistoricalValuesForProductBetweenDatesWithPreviousEntriesOffsetUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<HistoricalValueDTO>>(`${this.basePath}/api/historical-values/subset/${encodeURIComponent(String(productId))}/between-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}/offset/${encodeURIComponent(String(offset))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the list of Historical Values corresponding to the given product type id between the given dates
     * Retrieve the list of Historical Values corresponding to the given product type id between the given dates
     * @param productTypeId productTypeId
     * @param startDate startDate
     * @param endDate endDate
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForProductTypeBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe?: 'body', reportProgress?: boolean): Observable<Array<HistoricalValueDTO>>;
    public findHistoricalValuesForProductTypeBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductTypeBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductTypeBetweenDatesUsingGET(productTypeId: string, startDate: string, endDate: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findHistoricalValuesForProductTypeBetweenDatesUsingGET.');
        }
        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling findHistoricalValuesForProductTypeBetweenDatesUsingGET.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling findHistoricalValuesForProductTypeBetweenDatesUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<HistoricalValueDTO>>(`${this.basePath}/api/historical-values/by-product-type/${encodeURIComponent(String(productTypeId))}/between-dates/${encodeURIComponent(String(startDate))}/${encodeURIComponent(String(endDate))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the list of Historical Values corresponding to the given product type id
     * Retrieve the list of Historical Values corresponding to the given product type id
     * @param productTypeId productTypeId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForProductTypeIdUsingGET(productTypeId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<HistoricalValueDTO>>;
    public findHistoricalValuesForProductTypeIdUsingGET(productTypeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductTypeIdUsingGET(productTypeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HistoricalValueDTO>>>;
    public findHistoricalValuesForProductTypeIdUsingGET(productTypeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productTypeId === null || productTypeId === undefined) {
            throw new Error('Required parameter productTypeId was null or undefined when calling findHistoricalValuesForProductTypeIdUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<HistoricalValueDTO>>(`${this.basePath}/api/historical-values/by-product-type-id/${encodeURIComponent(String(productTypeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the list of Historical Values corresponding to the given product id until the given date
     * Retrieve the Historical Value corresponding to the given product id until the given date
     * @param productId productId
     * @param dateString dateString
     * @param valueOffset valueOffset
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForProductUntilDateUsingGET(productId: string, dateString: string, valueOffset: number, observe?: 'body', reportProgress?: boolean): Observable<PageHistoricalValueDTO>;
    public findHistoricalValuesForProductUntilDateUsingGET(productId: string, dateString: string, valueOffset: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHistoricalValueDTO>>;
    public findHistoricalValuesForProductUntilDateUsingGET(productId: string, dateString: string, valueOffset: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHistoricalValueDTO>>;
    public findHistoricalValuesForProductUntilDateUsingGET(productId: string, dateString: string, valueOffset: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling findHistoricalValuesForProductUntilDateUsingGET.');
        }
        if (dateString === null || dateString === undefined) {
            throw new Error('Required parameter dateString was null or undefined when calling findHistoricalValuesForProductUntilDateUsingGET.');
        }
        if (valueOffset === null || valueOffset === undefined) {
            throw new Error('Required parameter valueOffset was null or undefined when calling findHistoricalValuesForProductUntilDateUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<PageHistoricalValueDTO>(`${this.basePath}/api/historical-values/historical-values/subset/${encodeURIComponent(String(productId))}/${encodeURIComponent(String(dateString))}/${encodeURIComponent(String(valueOffset))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the list of Historical Values corresponding to the given product id until the given date
     * Retrieve the Historical Value corresponding to the given product id until the given date
     * @param productId productId
     * @param dateString dateString
     * @param valueOffset valueOffset
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findHistoricalValuesForProductUntilDateUsingGET1(productId: string, dateString: string, valueOffset: number, observe?: 'body', reportProgress?: boolean): Observable<PageHistoricalValueDTO>;
    public findHistoricalValuesForProductUntilDateUsingGET1(productId: string, dateString: string, valueOffset: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageHistoricalValueDTO>>;
    public findHistoricalValuesForProductUntilDateUsingGET1(productId: string, dateString: string, valueOffset: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageHistoricalValueDTO>>;
    public findHistoricalValuesForProductUntilDateUsingGET1(productId: string, dateString: string, valueOffset: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling findHistoricalValuesForProductUntilDateUsingGET1.');
        }
        if (dateString === null || dateString === undefined) {
            throw new Error('Required parameter dateString was null or undefined when calling findHistoricalValuesForProductUntilDateUsingGET1.');
        }
        if (valueOffset === null || valueOffset === undefined) {
            throw new Error('Required parameter valueOffset was null or undefined when calling findHistoricalValuesForProductUntilDateUsingGET1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<PageHistoricalValueDTO>(`${this.basePath}/api/historical-values/subset/${encodeURIComponent(String(productId))}/${encodeURIComponent(String(dateString))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the latest Historical Value corresponding to the given product id
     * Retrieve the latest Historical Value corresponding to the given product id
     * @param productId productId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findLatestHistoricalValueForProductUsingGET(productId: string, observe?: 'body', reportProgress?: boolean): Observable<HistoricalValueDTO>;
    public findLatestHistoricalValueForProductUsingGET(productId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HistoricalValueDTO>>;
    public findLatestHistoricalValueForProductUsingGET(productId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HistoricalValueDTO>>;
    public findLatestHistoricalValueForProductUsingGET(productId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productId === null || productId === undefined) {
            throw new Error('Required parameter productId was null or undefined when calling findLatestHistoricalValueForProductUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<HistoricalValueDTO>(`${this.basePath}/api/historical-values/subset/${encodeURIComponent(String(productId))}/latest`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve Historical Values corresponding to the given product name, with offset, starting with latest, backwards
     * Retrieve Historical Values corresponding to the given product name, with offset, starting with latest, backwards
     * @param productName productName
     * @param offset offset
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findLatestHistoricalValuesForProductNameWithOffsetUsingGET(productName: string, offset: number, observe?: 'body', reportProgress?: boolean): Observable<Array<HistoricalValuePresentationDTO>>;
    public findLatestHistoricalValuesForProductNameWithOffsetUsingGET(productName: string, offset: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HistoricalValuePresentationDTO>>>;
    public findLatestHistoricalValuesForProductNameWithOffsetUsingGET(productName: string, offset: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HistoricalValuePresentationDTO>>>;
    public findLatestHistoricalValuesForProductNameWithOffsetUsingGET(productName: string, offset: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (productName === null || productName === undefined) {
            throw new Error('Required parameter productName was null or undefined when calling findLatestHistoricalValuesForProductNameWithOffsetUsingGET.');
        }
        if (offset === null || offset === undefined) {
            throw new Error('Required parameter offset was null or undefined when calling findLatestHistoricalValuesForProductNameWithOffsetUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<Array<HistoricalValuePresentationDTO>>(`${this.basePath}/api/historical-values/by-product-name/${encodeURIComponent(String(productName))}/${encodeURIComponent(String(offset))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve the Historical Value corresponding to the given id
     * Retrieve the Historical Value corresponding to the given id
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistoricalValueUsingGET(id: string, observe?: 'body', reportProgress?: boolean): Observable<HistoricalValueDTO>;
    public getHistoricalValueUsingGET(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HistoricalValueDTO>>;
    public getHistoricalValueUsingGET(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HistoricalValueDTO>>;
    public getHistoricalValueUsingGET(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getHistoricalValueUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<HistoricalValueDTO>(`${this.basePath}/api/historical-values/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
